import { Injectable } from '@angular/core';
import {RequestProvider} from "../request/request";
import {ConfigProvider} from "../config/config";

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthProvider {


  public whoami: any = {};

  constructor(
    private request: RequestProvider,
    private configProvider: ConfigProvider
  )
  {
  }

  getToken(values): Promise<any> {
    values.db = this.configProvider.database;

    return new Promise((resolve, reject) => {
      this.request.post('auth/get_tokens', values, false).subscribe(data => {
        if (data && data.access_token) {
          localStorage.setItem("token", data.access_token);
          localStorage.setItem("expires", data.expires_in);
          localStorage.setItem("auth", data);
          resolve(data);
        } else {
          resolve(null);
        }
      }, err => {
        resolve(JSON.parse(err['_body']));
      });
    });
  }

  getTokenByLoginToken(loginToken): Promise<any> {
    let values = {
      'db': this.configProvider.database,
      'loginToken': loginToken
    };

    return new Promise((resolve, reject) => {
      this.request.post('auth/get_tokens', values, false).subscribe(data => {
        if (data && data.access_token) {
          localStorage.setItem("token", data.access_token);
          localStorage.setItem("expires", data.expires_in);
          localStorage.setItem("auth", data);
          resolve(data);
        } else {
          resolve(null);
        }
      }, err => {
        resolve(null);
      });
    });
  }

  getWhoami(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.request.get('whoami',true).subscribe(data => {
        this.whoami = data;
        resolve(data);
      }, err => {
        resolve(null);
      });
    });
  }

  createLoginToken(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.request.get('create-login-token',true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve(null);
      });
    });
  }

  clearLoginToken(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.request.get('clear-login-token',true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve(null);
      });
    });
  }

  logout() {
    localStorage.clear();
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts